import { Box } from '@mui/system';
import { ReactElement } from 'react';

type IconProp = {
  children: ReactElement
}

const AvatarWithIcon = ({ children }:IconProp): JSX.Element => {
  return (
    <Box sx={ {
      width: 35,
      height: 35,
      borderRadius: '50%',
      bgcolor: 'primary.main',
      position: 'relative',
      bottom: 15,
      right: 15,
      border: '2px solid #fff',
    } }
    >
      <Box
        sx={
          {
            top: '50%',
            left: '50%',
            color: '#fff',
            position: 'absolute',
            transform: 'translate(-50%, -50%)',
          }
        }
      >
        {children}
      </Box>
    </Box>
  );
};

export default AvatarWithIcon;
